import React, { Component } from 'react';
import './style.css';
import axios from 'axios'

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


import { api_url } from '../../../js_assets/ConfigApp';






const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 3,
        color: 'white',
        padding: '0px 15px',
    },
    input_field: {
        width: "100%",
        backgroundColor: "#f7faea;"

    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '100%',
        opacity: '0.9',
        borderRadius: '3px',

    },

    link: {
        textDecoration: 'none',
        color: '#4286f4',
        fontSize: 14

    }




});



class AdminAuthenticationContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            UserName: null,
            UserPassword: null
        };
    }

    redirectToUrl = (Component) => {

        window.location.href = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + Component
    }



    Login_User = (e) => {
        e.preventDefault();

        var UserAuth = {
            admin_Email: this.state.UserName,
            admin_Password: this.state.UserPassword,


        }

        axios.post(`${api_url}/api/Validation/LoginAdmin`, UserAuth)
            .then(rep => {
                if (rep.data.admin_Id === "error") {


                    alert("خطاء في اسم المستخدم او كلمة المرور")
                }
                else {
                    var Admin_Info = {
                        admin_Id: rep.data.admin_Id,
                        admin_Name: rep.data.admin_Name,
                        jwT_Token_Admin: rep.data.jwT_Token_Admin,

                    };

                    localStorage.setItem('Admin_Info', JSON.stringify(Admin_Info));

                    this.redirectToUrl(`/Admin/Trainers`)

                    return;
                }

            })
    }


    render() {




        return (


            <div className="login-box">
                <div className="login100-form-avatar  ">
                    <img src="/assets/imags/app_icon/Logo.png" alt="AVATAR" />
                </div>

                <div >

                    <input placeholder="الايميل" name="UserName" onChange={(e) => this.setState({ UserName: e.target.value })} />
                </div>

                <div >
                    <input placeholder="كلمة المرور" name="UserPassword" type="password" onChange={(e) => this.setState({ UserPassword: e.target.value })} />
                </div>
                <div className="center">
                    <button onClick={(e) => this.Login_User(e)} className="btn-login">
                        <label> دخول </label>
                    </button>
                </div>
            </div>
        )
    }



}

AdminAuthenticationContainer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminAuthenticationContainer);